import { render, staticRenderFns } from "./_articles.vue?vue&type=template&id=5561b9e4&scoped=true"
import script from "./_articles.vue?vue&type=script&lang=js"
export * from "./_articles.vue?vue&type=script&lang=js"
import style0 from "./_articles.vue?vue&type=style&index=0&id=5561b9e4&prod&lang=scss&scoped=true"
import style1 from "./_articles.vue?vue&type=style&index=1&id=5561b9e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561b9e4",
  null
  
)

export default component.exports